import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  @BlockUI() blockUI!: NgBlockUI;
  constructor() { }

  ngOnInit(): void {
    this.blockUI.reset();
  }

}
